import Category, { ActivateCategoryRequest, CreateCategoryRequest } from '@/models/Category';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { CategoryManagementTypes } from './types';

export const createCategoryRequest = (data: CreateCategoryRequest) => action(CategoryManagementTypes.CREATE_CATEGORY_REQUEST, data);

export const createCategorySuccess = () => action(CategoryManagementTypes.CREATE_CATEGORY_SUCCESS);

export const createCategoryFailure = (error: AxiosError<Category>) =>
    action(CategoryManagementTypes.CREATE_CATEGORY_FAILURE, {
        error,
    });

export const clearCategoryManagement = () => action(CategoryManagementTypes.CATEGORY_MANAGEMENT_CLEAR);

export const activateCategoryRequest = (data: ActivateCategoryRequest) => action(CategoryManagementTypes.ACTIVATE_CATEGORY_RESQUEST, data);

export const activateCategorySuccess = () => action(CategoryManagementTypes.ACTIVATE_CATEGORY_SUCCESS);

export const activateCategoryFailure = (error: AxiosError) => action(CategoryManagementTypes.ACTIVATE_CATEGORY_FAILURE, { error });

export const inactivateCategoryRequest = (data: ActivateCategoryRequest) => action(CategoryManagementTypes.INACTIVATE_CATEGORY_RESQUEST, data);

export const inactivateCategorySuccess = () => action(CategoryManagementTypes.INACTIVATE_CATEGORY_SUCCESS);

export const inactivateCategoryFailure = (error: AxiosError) => action(CategoryManagementTypes.INACTIVATE_CATEGORY_FAILURE, { error });
